module.exports = __webpack_public_path__ + "firefox_logo-only.bcea6117.svg";